module.exports = __webpack_public_path__ + "img/bg-image-1.0bf7e3d9.jpg";